import { Component, Input } from '@angular/core'
import { MediaInterface } from '../../interfaces'

@Component({
  selector: 'dmmp-website-detailed-banner',
  templateUrl: './website-detailed-banner.component.html',
})
export class WebsiteDetailedBannerComponent {
  @Input() identifier: string
  @Input() data: any
  @Input() module: any
  @Input() overlappingBox: boolean = false

  medias : MediaInterface[] = [
    { style: 'large', media: '(min-width:421px)' },
    { style: '289x290', media: '(min-width:421px)' },
    { style: '241x256', media: '(max-width:420px)' },
  ]
}
